import { Heading, Text } from '@axo/ui-core/components/typography';
import sanitizeHtml from 'sanitize-html';
import { IText } from '../types/IText';

export const CMSTextUI = ({ content }: { content: IText | IText[] | null }) => {
  if (!content) return null;
  if (Array.isArray(content))
    return (
      <>
        {content.map((c) => (
          <CMSTextUI key={c._id} content={c} />
        ))}
      </>
    );
  if (!('__typename' in content)) {
    throw new Error('missing typename in ' + JSON.stringify(content));
  }

  switch (content.__typename) {
    case 'Text':
      return <TermsContent key={content._id} {...content} />;
  }
};

interface TermsContentProps extends IText {
  classes?: {
    root?: string;
  };
}
const TermsContent = ({ body, text, format, classes }: TermsContentProps) => {
  if (format) {
    const isHeader = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(format);

    if (isHeader) {
      return (
        <Heading as={format.toLowerCase() as any} className={classes?.root}>
          {text}
        </Heading>
      );
    }
  }

  return (
    <Text
      className={classes?.root}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(body) }}
    />
  );
};
